import {
  PICKUP_STATUS_LABELS,
  STATUS_BADGE_CONFIG,
  DEFAULT_BADGE_CONFIG,
} from './index';
import { ColumnConfig } from '@/components/table/Table';
import { extractDate, extractTime } from '@/utils';
import { Badge } from '@/components';

export const pickUpTableColumns: ColumnConfig[] = [
  {
    label: 'Conductor',
    field: 'driver',
    render: (
      value: { id?: string; firstName?: string; lastName?: string } | null
    ) => {
      if (!value) return <span>-</span>;
      const fullName =
        `${value.firstName || ''} ${value.lastName || ''}`.trim();
      return <span>{fullName || '-'}</span>;
    },
  },
  {
    label: 'Comercio',
    field: 'commerceName',
    render: (value) => <span>{value || '-'}</span>,
  },
  {
    label: 'Fecha Creación',
    field: 'createdAt',
    sortable: true,
    render: (value: string | null) =>
      value ? (
        <span>
          {extractDate(value)} {extractTime(value)} hs
        </span>
      ) : (
        <span className='text-gray-400 italic'>-</span>
      ),
  },
  {
    label: 'Fecha Retiro',
    field: 'visitedAt',
    sortable: true,
    render: (value: string | null) =>
      value ? (
        <span>
          {extractDate(value)} {extractTime(value)} hs
        </span>
      ) : (
        <span className='text-gray-400 italic'>No retirado</span>
      ),
  },
  {
    label: 'Estado',
    field: 'status',
    render: (value: string) => {
      const label = PICKUP_STATUS_LABELS[value] || value || 'Desconocido';
      const config = STATUS_BADGE_CONFIG[value] || DEFAULT_BADGE_CONFIG;
      return (
        <div className='flex items-center w-fit'>
          <Badge value={label} {...config} density='compact' />
        </div>
      );
    },
  },
  {
    label: 'Cantidad',
    field: 'pickedCount',
    render: (value: number | undefined) => <span>{value ?? 0}</span>,
  },
];
